import { Injectable, inject } from '@angular/core';
import { FarewellApiService } from './farewell-api.service';
import { Observable } from 'rxjs';
import {
    FarewellScreenRequestItem,
    SessionSummaryEntity,
} from '@data-terminal/shared-models/session-summary.interface';

@Injectable({
    providedIn: 'root',
})
export class FarewellService {
    private readonly farewellApiService = inject(FarewellApiService);

    private farewellRequestItems: FarewellScreenRequestItem[] = [];

    public addFarewellRequestItems(items: FarewellScreenRequestItem[]): void {
        this.farewellRequestItems.push(...items);
    }

    public clearFarewellRequestItems(): void {
        this.farewellRequestItems = [];
    }

    public getFarewellScreenData(): Observable<SessionSummaryEntity[]> {
        return this.farewellApiService.getFarewellScreenData(this.farewellRequestItems);
    }

    public hasFarewellScreenData(): boolean {
        return this.farewellRequestItems.length > 0;
    }
}
